import { app } from './app';
import { auth } from './auth';
import { booking } from './booking';
import { data } from './data';
import { request } from './request';

import { Models } from '@rematch/core';

export interface RootModel extends Models<RootModel> {
	app: typeof app;
	auth: typeof auth;
	data: typeof data;
	booking: typeof booking;
	request: typeof request;
}

export const models: RootModel = { app, auth, data, booking, request };
